var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";
import InputLabel from "./InputLabel";
import { firstError } from "../../Services/Form";
const StyledInput = styled.input `
    padding: 20px 20px 20px 30px;
    background-color: transparent;
    border: 1px solid ${color.gray.light};
    width: 100%;
    box-sizing: border-box;
    outline: none;
    font-size: 16px;
    line-height: 1.2rem;
    max-width: 160px;
    color: #69696f;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:disabled {
        background-color: #eeeeee;
        cursor: default;

        + label {
            opacity: 0.5;
        }
    }
`;
const StyledInputWrapper = styled.div `
    position: relative;
`;
const StyledCurrencyIcon = styled.span `
    position: absolute;
    display: block;
    font-weight: 600;
    color: ${color.base.base};
    top: 50%;
    transform: translateY(-50%);
    line-height: 1rem;
    left: 15px;
`;
const InputCurrencyAmount = (_a) => {
    var { className, label, isMandatory, tooltipContents, value, error } = _a, props = __rest(_a, ["className", "label", "isMandatory", "tooltipContents", "value", "error"]);
    error = typeof error === "object" ? firstError(error) : error;
    return (React.createElement(React.Fragment, null,
        React.createElement(InputLabel, { isMandatory: isMandatory || props.required, tooltipContents: tooltipContents }, label),
        React.createElement(StyledInputWrapper, null,
            React.createElement(StyledCurrencyIcon, null, "\u20AC"),
            React.createElement(StyledInput, Object.assign({ "data-as-type": "currency_amount", type: "number", step: "0.01", className: className, value: value }, props))),
        !!error && React.createElement(ErrorLabel, null, _.capitalize(error))));
};
export default InputCurrencyAmount;
